export const messages = {
  en: {
    allocationStorehouseAuditOrders: {
      title: 'Pending Orders',
      back: 'Back',
      refresh: 'Refresh',
      scheduleNo: 'Schedule No',
      allocationCount: 'Allocation Count',
      applicant: 'Applicant',
      status: 'Status',
      time: 'Time',
      operation: 'Operation',
      view: 'View',
      edit: 'Edit',
      allocation: 'Allocation',
      approve: 'Approve'
    }
  },
  zh: {
    allocationStorehouseAuditOrders: {
      title: '待办单',
      back: '返回',
      refresh: '刷新',
      scheduleNo: '调度编号',
      allocationCount: '调拨数量',
      applicant: '申请人',
      status: '状态',
      time: '时间',
      operation: '操作',
      view: '查看',
      edit: '修改',
      allocation: '调拨',
approve: '审批'
    }
  },
  'zh-TW': {
    allocationStorehouseAuditOrders: {
      title: '待辦單',
      back: '返回',
      refresh: '刷新',
      scheduleNo: '調度編號',
      allocationCount: '調撥數量',
      applicant: '申請人',
      status: '狀態',
      time: '時間',
      operation: '操作',
      view: '查看',
      edit: '修改',
      allocation: '調撥',
      approve: '審批'
    }
  }
}